import type { MenuProps } from 'antd';
import { EHeaderNavItemLabel, ERoute } from 'common/const/enum';

export const headerNavItems: MenuProps['items'] = [
  {
    label: EHeaderNavItemLabel.Dashboard,
    key: ERoute.Dashboard,
  },
];
